import React from 'react';
import './cotacao.scss';
import {TextField, MenuItem, IconButton, Tooltip} from '@material-ui/core';
import {Alert, Grow} from '@mui/material';
import {withStyles} from "@material-ui/core/styles";
// import InfoIcon from '@material-ui/icons/Info';
import moment from 'moment';
import CurrencyInput from 'react-currency-input-field';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import currency from '../../helper/currency';
import arrow_down from '../../assets/images/arrow_down.png';
import division from '../../assets/images/division.png';
import equal from '../../assets/images/equal.png';
import info from '../../assets/images/info.png';
import line2 from '../../assets/images/line2.png';
import subtraction from '../../assets/images/subtraction.png';
import bandeiraEuro from '../../assets/images/bandeira-euro.png';

moment.locale('br');

const styles = theme => ({
  customTooltip: {
    color: "white !important",
  },
  customInfoIcon: {
    width: "1.25rem"
  },
  customIconSelect: {
    color: "white !important",
    marginRight: "0.37rem",
    paddingBottom: "0.62rem" ,
    marginTop: "0.31rem"
  }
});

class Cotacao extends React.Component {

  state = {
    typing: false,
    typingTimeout: 0
  }  

  Cotar = (name) => {
    const {cotar, setValue} = this.props;   
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }   

    setValue(null, "textWarning")
    self.setState({
      typing: false,
      typingTimeout: setTimeout(function () {
        cotar(name);
      }, 1000)
    });  
  }

  componentWillMount() {
    const{init} = this.props;
    init();
  }

  renderTooltipIOF() {
    // const { result, form, tarifa } = this.props.cotacao;
    const { classes } = this.props;
    return (
      <div className={classes.customTooltip}>
        O imposto sobre Operações Financeiras(IOF) é aplicado sobre o valor total em BRL na operação, e pode variar de acordo com o tipo de transação realizada.
        {/* A Tarifa ({currency(result.valorIof)} {form.paisEnvia.IdMoeda}) é composta por:<br/>
        IOF ({currency(result.valorIof)} {form.paisEnvia.IdMoeda}) + Tarifa ({currency(tarifa)} BRL)<br/><br/>
        O <b className={classes.customTooltip}>Imposto sobre Operações Financeiras (IOF)</b><br/>
        é aplicado sobre o valor total em transferências BRL.<b/><br/>
        <ul>
          <li className={classes.customTooltip}>Para sua conta: 1,1%</li>
          <li className={classes.customTooltip}>Para conta de outra pessoa: 0,38%</li>
        </ul> */}
      </div>
    )
  }

  renderTooltipVET() {
    const { classes } = this.props;
    return (
      <div className={classes.customTooltip}>
        <b className={classes.customTooltip}>Valor efetivo (VET)</b><br/><br/>
        O <b className={classes.customTooltip}>Valor Efetivo Total (VET) </b>combina o câmbio,<br/>
        o imposto sobre Operações Financeiras (IOF)<br/>
        e o preço cobrado.
      </div>
    )
  }

  renderTooltipPrazo() {
    const { classes } = this.props;
    return (
      <div className={classes.customTooltip}>
        O prazo poderá sofrer alterações conforme a forma de pagamento escolhida.
      </div>
    )
  }

  renderTooltipTaxaCambio() {
    const { classes } = this.props;
    return (
      <div className={classes.customTooltip}>
        O valor simulado pode sofrer variação dependendo da forma de pagamento, país de destino e tipo de envio escolhido.
      </div>
    )
  }

  getNomeBandeiraMoedaPais = (item) => {
    const{paises} = this.props.cotacao;
    const result = {
      ArquivoBandeira: "",
      NomePais: item.NomePais
    }
    if (item.IdMoeda.toUpperCase() === "EUR") {
      result.ArquivoBandeira = bandeiraEuro;
      result.NomePais = "Europa";
    } else if (item.IdMoeda.toUpperCase() === "USD") {
      result.ArquivoBandeira = paises.find(x => x.IdPais.toUpperCase() === "USA").ArquivoBandeira;
      result.NomePais = "Estados Unidos";
    } else {
      result.ArquivoBandeira = paises.find(x => x.IdPais.toUpperCase() === item.IdPais.toUpperCase()).ArquivoBandeira;
    }

    return result;
  }

  onChange = (value, name) => {
    const {setForm, setUltAltVR} = this.props;
    const {form} = this.props.cotacao;
 
    const valueSplit = value.split(",");
    if (valueSplit.length > 1) {
      const expoente = valueSplit[1].length - 2;
      if (expoente > 0) {
        value = parseFloat(value.replace(",","."));
        value = (value * (Math.pow(10, expoente))).toFixed(2)
      } else {
        value = parseFloat(value.replace(",","."));
        value = (value / (Math.pow(10, Math.abs(expoente)))).toFixed(2)
      }
    } else {
      value = parseFloat(value / 100).toFixed(2);
    }

    setForm(value.toString(), name);

    if (name === "valorRecebe") {
      setUltAltVR(true)
    } else if (name === "valorEnvia") {
      setUltAltVR(false)
    }
    
    if (form[name] === null || value !== form[name].replace(",",".")) {
      this.Cotar(name);               
    }             
  }

  render() {
    const {setForm, classes} = this.props;

    let {
      form,
      result,
      paises,
      paisMoedas,
      loading,  
      textWarning,
      textError,
      ultAltValorRecebe
    } = this.props.cotacao;

    if (loading)
      return <Skeleton height={460}/>

    return (
      <Grow  
        in={!loading}
        {...(!loading ? { timeout: 1000 } : {})}
      >
      <div className="box-cotacao">
        <div className="section-cotacao">
          {textError && (
            <Alert severity="error">{textError}</Alert>
          )} 
          {textWarning && (
            <Alert severity="warning">{textWarning}</Alert>
          )}   
          <label htmlFor="valorEnvia" >Você envia</label>
          <div className="voce-envia">
            <CurrencyInput
              id="valorEnvia"  
              name="valorEnvia"
              decimalsLimit={3}
              allowNegativeValue={false}
              decimalSeparator=","
              groupSeparator="."
              value={form.valorEnvia}
              onValueChange={(value, name) => {        
                this.onChange(value, name);
              }}
              ref={(input) => { this.nameInput = input; }}
              onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
            />
            <TextField
              id="moeda"
              name="paisEnvia"
              className="moedaPaisEnvia"
              select
              value={form.paisEnvia.IdPais}
              onChange={(event) => {
                const value = paisMoedas.find(x => x.IdPais === event.target.value);
                setForm(value, event.target.name);
                this.Cotar("valorEnvia");
              }}
              InputProps={{ disableUnderline: true }}
              disabled={true}
            >
              {paises.map((pais, index) => 
                <MenuItem key={index} value={pais.IdPais} selected={pais.IdPais === "BRA"}>
                  <img src={pais.ArquivoBandeira} alt="bandeira-pais-moeda" width="30" /> {pais.IdMoedaLocal}
                </MenuItem >
              )}     
            </TextField>
          </div>     
          
          <div className="resultado-cotacao">
            <div className="linha_cotacao">
              <img src={line2} alt="line" height="75%" />
            </div>
            
            <table className="valores">
              <tbody>
                <tr height="20" align="top">
                  <td align="center">
                    <div className="sinais">
                      <img src={subtraction} alt="subtraction"/>
                    </div>
                  </td>
                  <td align="left" className="res-valor">
                  <b>{currency(result.valorIof)}&nbsp;{form.paisEnvia.IdMoeda}</b>
                    &nbsp; IOF
                    <Tooltip title={this.renderTooltipIOF()}>
                      <IconButton >
                        <img src={info} alt="info" className="infoIOF"/>
                        {/* <InfoIcon className={classes.customInfoIcon} /> */}
                      </IconButton>
                    </Tooltip>
                  </td>
                  {/* <td align="left">
                    IOF
                    <Tooltip title={this.renderTooltipIOF()}>                 
                      <IconButton >
                        <img src={info} alt="info" className="infoIOF"/>                        
                      </IconButton>
                    </Tooltip>
                  </td> */}
                </tr>
                <tr height="20">
                  <td align="center">
                    <div className="sinais">
                      <img src={equal} alt="equal"/>
                    </div>
                  </td>
                  <td align="left" className="res-valor">
                    <b>{currency(result.valorEnvia - result.valorIof, "pt-BR", true, 2)}&nbsp;{form.paisEnvia.IdMoeda}</b>
                    &nbsp; Valor convertido
                  </td>
                </tr>
                <tr height="20">
                  <td align="center">
                    <div className="sinais">
                      <img src={division} alt="division"/>
                    </div>
                  </td>
                  <td align="left" className="res-valor taxa-cambio">
                    <b>{currency(result.taxaCambio)}&nbsp;{form.paisEnvia.IdMoeda}</b>                   
                    &nbsp; Taxa de câmbio comercial
                    <Tooltip title={this.renderTooltipTaxaCambio()} className="tooltip-taxacambio">                 
                      <IconButton >
                        <img src={info} alt="info" className="infoIOF"/>
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>          

          {/* <div className="valor-unidade-moeda">
            <span className="conversao">
              1 {form.paisRecebe.IdMoeda} = {currency(result.valorTaxaVET)} {form.paisEnvia.IdMoeda}&nbsp;Valor efetivo (VET)               
            </span>
            <Tooltip title={this.renderTooltipVET()}>
              <IconButton>
                <img src={info} alt="info" className="infoVET"/>
              </IconButton>
            </Tooltip>
          </div>  

          <div className="prazo-chegada">
            <img src={calendar2} alt="calendar2" />
            <div>
              O dinheiro deverá chegar<br/><span>em até {result.prazoChegada} dias úteis</span>&nbsp;             
            </div>
            <Tooltip title={this.renderTooltipPrazo()}>
              <IconButton>
                <img src={info} alt="info" />
              </IconButton>
            </Tooltip>
          </div> */}

          <label htmlFor="valorRecebe" >Beneficiário recebe</label>
          <div className="beneficiario-recebe">
            <CurrencyInput
              id="valorRecebe"  
              name="valorRecebe"
              decimalsLimit={3}
              allowNegativeValue={false}
              decimalSeparator=","
              groupSeparator="."
              value={form.valorRecebe}
              ref={(input) => { this.nameInput = input; }}
              onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
              onValueChange={(value, name) => {
                this.onChange(value, name);
              }}
            />
            <TextField
              id="moeda"
              name="paisRecebe"
              className="moedaPaisRecebe"
              select
              value={form.paisRecebe.Id}
              onChange={(event) => {
                const value = paisMoedas.find(x => x.Id === event.target.value);
                setForm(value, event.target.name);
                this.Cotar(ultAltValorRecebe ? "valorRecebe" : "valorEnvia");  
              }}
              InputProps={{ disableUnderline: true }}
              SelectProps={{
                renderValue: option => { 
                  if (option === undefined)
                    return <></>
                  const paisMoeda = paisMoedas.find(x => x.Id === option);
                  return (                                    
                    paisMoeda !== undefined ? (
                      <div>
                        <img src={this.getNomeBandeiraMoedaPais(paisMoeda).ArquivoBandeira} alt="arquivo-bandeira-pais" width="30" /> {paisMoeda.IdMoeda}
                      </div>
                    ) : (<></>)                 
                )},
                IconComponent: (props) => <img {...props} src={arrow_down} alt="arrow_down" className={`material-icons MuiSelect-icon ${classes.customIconSelect}`}/>
              }}
            >
              {paisMoedas.map((pais, index) => 
                <MenuItem key={index} value={pais.Id} selected={pais.IdPais === "USA"}>
                  {pais.NomeMoeda.toUpperCase()} - {this.getNomeBandeiraMoedaPais(pais).NomePais}
                </MenuItem >
              )}     
            </TextField>
          </div>       
        </div> 
      </div>
      </Grow>     
    );
  }
}

export default withStyles(styles)(Cotacao);

